import { motion } from "framer-motion";

const FlashingDotSVG = ({ position }) => {
  const relativeY = position.y * window.innerHeight / 870;
  const relativeX = position.x * window.innerWidth / 1512;

  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      className="absolute"
      style={{position:'absolute', left: `${relativeX}px`, top: `${relativeY}px`, cursor:'pointer'}}
    >
      
      <circle cx="25" cy="25" r="5" fill="white" />

      <motion.circle
        cx="25"
        cy="25"
        r="20"
        stroke="white"
        strokeWidth="2"
        fill="none"
        initial={{ scale: 0, opacity: 1 }}
        animate={{ scale: 1, opacity: 0 }}
        transition={{
          duration: 3,
          repeat: Infinity,
          ease: "easeInOut",
          delay: `${Math.random() * 3}` 
        }}
      />
    </svg>
  );
};

export default FlashingDotSVG;